import { CategorySort as SourceCategorySort } from 'SourceComponent/CategorySort/CategorySort.component';

export class CategorySort extends SourceCategorySort {
    render() {
        const { totalItems } = this.props;

        if (totalItems === 0) {
            return null;
        }

        return (
            <div block="CategorySort">
                { this.renderSortField() }
            </div>
        );
    }
}

export default CategorySort;
